import { render, staticRenderFns } from "./daijiaoban.vue?vue&type=template&id=18bbb529&scoped=true&"
import script from "./daijiaoban.vue?vue&type=script&lang=js&"
export * from "./daijiaoban.vue?vue&type=script&lang=js&"
import style0 from "./daijiaoban.vue?vue&type=style&index=0&id=18bbb529&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bbb529",
  null
  
)

export default component.exports